import { Component, Input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ClientsService } from 'src/app/services/clients/clients.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { CreditDisplayComponent } from '../../credit-display/credit-display.component';
import { PayeeLanguageSelectorComponent } from '../../../shared/payee-language-selector/payee-language-selector.component';
import { PayeeIconButtonComponent } from '../../../shared/payee-buttons/payee-icon-button/payee-icon-button.component';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    CreditDisplayComponent,
    PayeeLanguageSelectorComponent,
    PayeeIconButtonComponent,
    PayeeIconComponent,
    RouterLink,
    TranslateModule,
  ],
})
export class HeaderComponent {
  private clientsService = inject(ClientsService);
  private authService = inject(AuthService);

  @Input({ required: true }) title!: string;
  @Input() subtitle?: string;

  get showCreditDisplay(): boolean {
    const selectedClient = this.clientsService.selectedClientSubject.value;
    return !!selectedClient?.uses_credits;
  }

  async logout(): Promise<void> {
    await this.authService.logout();
  }
}
